import React from 'react';
import PropTypes from 'prop-types';

import ProductPropertyTab, { PropertyList } from '../../molecules/product-detail-accordion';

const FullListIngredients = (props) => {
  if (!props.product) return null;

  const ingredients = props.product?.product_properties?.filter(
    (property) => property.property_name === 'Full List of Ingredients'
  );

  if (!ingredients || ingredients.length === 0) return null;

  return (
    <ProductPropertyTab title="Full List of Ingredients">
      <PropertyList element="ul" like="paragraph-2">
        {
          ingredients.map(({ value }) => (
            <li key={value}>{value}</li>
          ))
        }
      </PropertyList>
    </ProductPropertyTab>
  );
};
FullListIngredients.propTypes = {
  product: PropTypes.object.isRequired
};

export default FullListIngredients;
